<template>
<div>
  <el-row class="title-bar" type="flex" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <div class="vertical-center-box">
      <el-radio-group class="mr-r10" v-model="dataType">
        <el-radio :label="dataTypeData.volumn" @change="onDataTypeChange">볼륨 기준</el-radio>
        <el-radio :label="dataTypeData.volumnType" @change="onDataTypeChange">볼륨 타입 기준</el-radio>
      </el-radio-group>
      <w-header-search-button @click="onShowSearchToolClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- 볼륨 기준 -->
  <el-table-wrapper v-show="dataType === dataTypeData.volumn" v-loading="isLoading.volumn" :data="tableData.volumn" :columns="columns.volumn"
  :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.volumn">
    <template slot-scope="scope" slot="tablespace-userate-slot">
      <el-progress v-if="scope.row['TABLESPACE/DB_TABLESPACE_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TABLESPACE/DB_TABLESPACE_USERATE'])"></el-progress>
      <span v-else> - </span>
    </template>
  </el-table-wrapper>
  <!-- 볼륨 타입 기준 -->
  <el-table-wrapper v-show="dataType === dataTypeData.volumnType" v-loading="isLoading.volumnType" :data="tableData.volumnType" :columns="columns.volumnType"
  :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.volumnType">
    <template slot-scope="scope" slot="datafile-userate-slot">
      <el-progress v-if="scope.row['CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE'])"></el-progress>
      <span v-else> - </span>
    </template>
  </el-table-wrapper>
</div>
</template>

<script>
import { isNil, floor } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WSpaceUtilizationCubridTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      dataType: 'VOLUMN_STANDARD',
      dataTypeData: {
        volumn: 'VOLUMN_STANDARD',
        volumnType: 'VOLUMN_TYPE_STANDARD',
      },
      tableData: {
        volumn: [],
        volumnType: [],
      },
      isLoading: {
        volumn: false,
        volumnType: false,
      },
      showSearchTool: {
        volumn: false,
        volumnType: false,
      },
      checkDatetime: null,
      columnDefault,
      columns: {
        volumn: [
          { prop: 'rscKeyName', label: '볼륨 명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'CU_VOL_PAGE/DBCU_VOL_TYPE', label: '공간타입', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TABLESPACE/DB_TABLESPACE_USERATE', label: '사용률(%)', sortable: true, scopedSlot: 'tablespace-userate-slot' },
          { prop: 'TABLESPACE/DB_TABLESPACE_TOTSIZE', label: '전체', sortable: true, formatter: this.convertMValue },
          { prop: 'TABLESPACE/DB_TABLESPACE_USEDSIZE', label: '사용량', sortable: true, formatter: this.convertMValue },
          { prop: 'TABLESPACE/DB_TABLESPACE_AVSIZE', label: '가용량', sortable: true, formatter: this.convertMValue },
          { prop: 'CU_VOL_PAGE/DBCU_VOL_TOTPAGE', label: '전체 페이지 수', sortable: true, formatter: this.convertCountValue },
          { prop: 'CU_VOL_PAGE/DBCU_VOL_USEDPAGE', label: '사용 페이지 수', sortable: true, formatter: this.convertCountValue },
          { prop: 'CU_VOL_PAGE/DBCU_VOL_AVPAGE', label: '가용 페이지 수', sortable: true, formatter: this.convertCountValue },
        ],
        volumnType: [
          { prop: 'rscKeyName', label: '볼륨 타입 명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE', label: '사용률(%)', sortable: true, scopedSlot: 'datafile-userate-slot' },
          { prop: 'CU_TABLESPACE/DBCU_VOL_TOTSIZE_BY_PURPOSE', label: '전체 크기', sortable: true, formatter: this.convertKValue },
          { prop: 'CU_TABLESPACE/DBCU_VOL_USEDSIZE_BY_PURPOSE', label: '사용량', sortable: true, formatter: this.convertKValue },
          { prop: 'CU_TABLESPACE/DBCU_VOL_AVSIZE_BY_PURPOSE', label: '가용량', sortable: true, formatter: this.convertKValue },
          { prop: 'CU_TABLESPACE/DBCU_VOL_COUNT_BY_PURPOSE', label: '볼륨 수', sortable: true, formatter: this.convertCountValue },
        ],
      },
    };
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.dataType === this.dataTypeData.volumn) {
        this.loadVolumnData();
      } else if (this.dataType === this.dataTypeData.volumnType) {
        this.loadVolumnTypeData();
      }
    },
    /**
     * 볼륨 기준 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadVolumnData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = this.getCommonParamsForCurrent();
        params.objtypeId = this.selectedNode.obj.objtypeId;
        this.isLoading.volumn = true;
        databaseTableInfoAPI.getCurrentTablespace(params).then((result) => {
          if (result.data.success === true) {
            this.tableData.volumn = result.data.data;
          } else {
            this.failToLoadVolumnData();
          }
        }).catch(() => {
          this.failToLoadVolumnData();
        }).finally(() => {
          this.isLoading.volumn = false;
        });
      } else {
        const params = this.getCommonParamsForHist();
        databaseTableInfoAPI.getTablespaceCubridList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.volumn = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadVolumnData();
          }
        }).catch(() => {
          this.failToLoadVolumnData();
        }).finally(() => {
          this.isLoading.volumn = false;
        });
      }
    },
    /**
     * 볼륨 타입 기준 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadVolumnData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '공간 사용률', false));
    },
    /**
     * 볼륨 타입 기준 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadVolumnTypeData() {
      if (this.timeType === analysisTimeType.CURRENT.value) {
        const params = this.getCommonParamsForCurrent();
        this.isLoading.volumnType = true;
        databaseTableInfoAPI.getCurrentTablespaceTypeCubrid(params).then((result) => {
          if (result.data.success === true) {
            this.tableData.volumnType = result.data.data;
          } else {
            this.failToLoadVolumnTypeData();
          }
        }).catch(() => {
          this.failToLoadVolumnTypeData();
        }).finally(() => {
          this.isLoading.volumnType = false;
        });
      } else {
        const params = this.getCommonParamsForHist();
        this.isLoading.volumnType = true;
        databaseTableInfoAPI.getTablespaceCubridTypeList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.volumnType = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadVolumnTypeData();
          }
        }).catch(() => {
          this.failToLoadVolumnTypeData();
        }).finally(() => {
          this.isLoading.volumnType = false;
        });
      }
    },
    /**
     * 볼륨 타입 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadVolumnTypeData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '공간 사용률', false));
    },
    /**
     * 현재 데이터 조회 시 공통 파라미터 객체 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParamsForCurrent() {
      return {
        objId: this.selectedNode.obj.objId,
      };
    },
    /**
     * 이력 데이터 조회 시 공통 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParamsForHist() {
      return {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onDataTypeChange() {
      this.checkDatetime = null;
      this.loadData();
    },
    /**
     * [onShowSearchToolClick 검색 show]
     * @author {Yang}
     */
    onShowSearchToolClick() {
      if (this.dataType === this.dataTypeData.volumn) {
        this.showSearchTool.volumn = !this.showSearchTool.volumn;
      } else if (this.dataType === this.dataTypeData.volumnType) {
        this.showSearchTool.volumnType = !this.showSearchTool.volumnType;
      }
    },
    /**
     * [convertMValue VOLUMN_STANDARD 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertMValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'MB', false, false, true);
    },
    /**
     * [datafileTKbytesFormatter VOLUMN_TYPE_STANDARD 컬럼 포맷]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertKValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'KB', false, false, true);
    },
    convertCountValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'count', true, false, true);
    },
    /**
     * [getPercentage 프로그래스바 * 100]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : floor(value, 2);
    },
    /**
     * [convertFormatter 단위변환]
     * @author {Yang}
     * @param  {[type]} value [값]
     * @param  {[type]} unit  [단위]
     * @return {[type]}       [description]
     */
    convertFormatter(value, unit) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, unit, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/SpaceUtilization/SpaceUtilizationCubridTable.vue